
import { defineComponent } from 'vue'

type ListStyleTypes = 'circle' | 'disc'

export default defineComponent({
  name: 'TimelineItemV2',

  props: {
    listStyleType: {
      type: String as () => ListStyleTypes,
      default: 'disc',
      validator: (val: string) => ['circle', 'disc'].includes(val)
    }
  },

  computed: {
    listStyleClasses(): string {
      const classMap: Record<ListStyleTypes, string> = {
        circle: 'border border-slate-200 bg-transparent',
        disc: 'bg-slate-200'
      }

      return classMap[this.listStyleType]
    }
  }
})
